module.exports = __webpack_public_path__ + "img/Gran_Coupé.ccec182b.jpg";